/**
 * Reads `file` and base64-encodes it — extracted from `api/patientPhoto.ts` (`BACKLOG.md` C18) once
 * `api/calendarSync.ts` (`BACKLOG.md` K7) needed the identical logic a second time, per
 * `claude-kit/rules/invariants.md`'s "favor the general, reusable solution once a pattern actually
 * recurs." `FileReader.readAsDataURL` rather than a byte-by-byte loop over `arrayBuffer()`: the
 * browser's own base64 encoder, not a hand-rolled one, and the `data:` prefix up to the first comma
 * is the only part that needs stripping.
 */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => {
      reject(reader.error ?? new Error('failed to read the selected file'));
    };
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('unexpected FileReader result reading the selected file'));
        return;
      }
      const commaIndex = result.indexOf(',');
      resolve(commaIndex === -1 ? result : result.slice(commaIndex + 1));
    };
    reader.readAsDataURL(file);
  });
}
